import { Button, Space, Tag } from "antd";
import { setIcons } from "@/utils/common";
import { appUserBaseList } from "@/api/index";
import { deviceTypeOptions } from "@/utils/enums";
// import { useState } from "react";

// 流水收益分佣类型选项
const deviceFlowRewardTypeOptions = [
  {
    label: "通用模式",
    value: 0,
  },
  {
    label: "自定义模式",
    value: 1,
  },
  {
    label: "不分佣",
    value: 2,
  },
];

export const  formTab = [
  // {
  //   label: "用户业务ID",
  //   name: "userBusinessId",
  //   type: "input",
  // },
  {
    label: "用户账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "流水收益分佣类型",
    name: "deviceFlowRewardType",
    type: "select",
    width: "320px",
    options: deviceFlowRewardTypeOptions,
  },
  {
    label: "设备类型",
    name: "deviceType",
    type: "select",
    options: deviceTypeOptions,
  },
  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
    params: {
      defaultTimer: [
      ],
    },
  },
]

// 防抖函数
let searchTimer: NodeJS.Timeout | null = null;

export const modalFormTab = (setDeviceFlowRewardType: any, deviceFlowRewardType?: number, userList?: any[], getUserList?: any) => [
  {
    label: "分佣用户",
    name: "userId",
    type: "select",
    options: userList,
    params: {
      onSearch: (val: string) => {
        if (searchTimer) {
          clearTimeout(searchTimer);
        }
        searchTimer = setTimeout(() => {
          if (val.trim()) {
            getUserList(val);
          }
        }, 300); // 300ms 防抖延迟
      },
      allowClear: true,
      showSearch: true,
      filterOption: false, // 关闭本地过滤，使用远程搜索
      placeholder: "请输入用户账号搜索",
      notFoundContent: userList?.length === 0 ? "暂无数据" : "请输入关键字搜索",
    },
    labelCol: { span: 10, offset: 0 },
    width: "320px",
    rules: [{ required: true, message: "请选择用户账号" }],
  },
  {
    label: "设备类型",
    name: "deviceType",
    type: "select",
    options: deviceTypeOptions,
    rules: [{ required: true, message: "请选择设备类型" }],
    labelCol: { span: 10, offset: 0 },
    width: "320px",
  },
  {
    label: "流水分佣类型",
    name: "deviceFlowRewardType",
    type: "select",
    options: deviceFlowRewardTypeOptions,
    rules: [{ required: true, message: "请选择流水分佣类型" }],
    width: "320px",
    // labelCol: { span: 32, offset: 0 },
    params: {
      // width: "380px",
      onChange: (val: number) => {
        console.log('编辑时 onChange 被调用, 新值:', val, '类型:', typeof val);
        setDeviceFlowRewardType(val);
      },
    },
  },
  {
    label: "流水最大值",
    name: "deviceFlowRewardMax",
    type: "input",
    labelCol: { span: 8, offset: 2 },
    width: "320px",
    show: deviceFlowRewardType === 1,
    rules: [
      { required: true, message: "请输入流水最大值" },
      { pattern: /^[1-9]\d*(\.\d)?$/, message: "请输入大于0且最多一位小数的数字" }
    ],
    params: {
      type: "number",
    },
  },
  {
    label: "流水最小值",
    name: "deviceFlowRewardMin",
    type: "input",
    labelCol: { span: 8, offset: 2 },
    width: "320px",
    show: deviceFlowRewardType === 1,
    rules: [
      { required: true, message: "请输入流水最小值" },
      { pattern: /^[1-9]\d*(\.\d)?$/, message: "请输入大于0且最多一位小数的数字" }
    ],
    params: {
      type: "number",
    },
  },

  {
    label: "备注",
    name: "remark",
    type: "textArea",
    labelCol: { span: 10, offset: 0 },
    width: "320px",
  },
];


export const columns = ({
  setModalFormData,
  setOpen,
  deleteCommissionData,
  editCommissionData
}: {
  setModalFormData: any;
  setOpen: any;
  deleteCommissionData: any;
  editCommissionData: any;
}) => [
  {
    title: "用户ID",
    dataIndex: "userId",
    key: "userId",
  },
  {
    title: "昵称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "账号",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "设备类型",
    dataIndex: "deviceType",
    key: "deviceType",
    render: (val: number) => {
      const type = deviceTypeOptions.find((item) => item.value === val);
      return type ? <Tag color="blue">{type.label}</Tag> : "";
    },
  },
  {
    title: "流水收益分佣类型",
    dataIndex: "deviceFlowRewardType",
    key: "deviceFlowRewardType",
    render: (val: number) => {
      const type = deviceFlowRewardTypeOptions.find((item) => item.value === val);
      return type ? <Tag color="blue">{type.label}</Tag> : "";
    },
  },
  {
    title: "流水最小值",
    dataIndex: "deviceFlowRewardMin",
    key: "deviceFlowRewardMin",
    render: (val: number, row: any) => {
      if (row.deviceFlowRewardType === 1) {
        return val ? val : "-";
      } else {
        return "-";
      }
    },
  },
  {
    title: "流水最大值",
    dataIndex: "deviceFlowRewardMax",
    key: "deviceFlowRewardMax",
    render: (val: number, row: any) => {
      if (row.deviceFlowRewardType === 1) {
        return val ? val : "-";
      } else {
        return "-";
      }
    },
  },

  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },

  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  // {
  //   title: "更新时间",
  //   dataIndex: "updateTime",
  //   key: "updateTime",
  // },
  {
    title: "操作",
    dataIndex: "id",
    key: "operation",
    fixed: "right",
    width: "120px",
    render: (val: string, rows: any) => (
      <Space>
        <Button
          size="small"
          icon={setIcons("EditOutlined")}
          type="text"
          onClick={(e) => {
            editCommissionData(rows);
          }}
        >
          修改
        </Button>
        <Button
          size="small"
          icon={setIcons("DeleteOutlined")}
          type="text"
          onClick={(e) => {
            deleteCommissionData(rows.id);
          }}
        >
          删除
        </Button>
      </Space>
    ),
  },
];
